export default __webpack_public_path__ + "static/media/vault-icon.571af0f9.svg";